import styled, { css } from 'styled-components'

import { COLORS2 } from '~/common/globalStyles'
import { styles } from '~/views/components/ui/inputs/v2/shared/components/inputElements'

interface InputWrapperProps {
  isFocused: boolean
  isDisabled?: boolean
  internalOnly?: boolean
}

const InputWrapper = styled.div<InputWrapperProps>`
  ${styles.baseInput};
  display: flex;
  border-color: ${COLORS2.gray[50]};
  box-shadow: inset 0 1px 2px 0 rgba(207, 215, 230, 0.4);

  ${({ isFocused }) => isFocused && styles.focus} ${({ isDisabled }) =>
    isDisabled &&
    css`
        background-color: #e3e7f1;
        &,
      `};
  ${({ theme }) => `
    &&& {
      input:-webkit-autofill,
      input:-webkit-autofill:hover, 
      input:-webkit-autofill:focus, 
      input:-webkit-autofill:active {
        box-shadow: ${theme.palette.background.paper} 0px 0px 0px 30px inset;
        -webkit-text-fill-color: ${theme.palette.text.primary} !important;
      }
    }
  `}
`

export default InputWrapper
